import React, {useContext, useEffect, useState} from "react";
import {Grid, Box, Typography, makeStyles, MenuList, MenuItem, Divider, ListItemText} from "@material-ui/core";
import PropTypes from "prop-types";
import {useBreakpoints, useKeycloakFunctions} from "../../../hooks";
import {LocaleContext} from "../../../store/providers/LocaleProvider";
import {CurrencyContext} from "../../../store/providers/CurrencyProvider";
import ArrowRight from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-right-1.svg";
import ArrowLeft from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-left-1.svg";
import {useI18N, useLocation} from "../../../common/common";
import LanguageSelect from "../../widget/select/languageSelect/LanguageSelect";
import CurrencySelect from "../../widget/select/currencySelect/CurrencySelect";
import * as ROUTES from "../../../common/routes";
import clsx from "clsx";
import {CustomButton, CountryIcon, StreamlineIcon} from "@hapinest/theme";
import {toTitleCase} from "../../../common/string";
import {checkYearEndProcessing} from "../../../common/configcat/functions";
import {withSnackbar} from "../../hoc/SnackbarHOC";
import {useAnalytics} from "../../../store/providers/AnalyticsProvider";


const useStyles = makeStyles((theme) => ({
    backIcon: {
        marginTop: theme.spacing(0.75)
    },
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    menuList: {
        padding: 0
    },
    profileMenuItemTop: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    profileMenuItemBottom: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    profileMenuItemIcon: {
        padding: 0,
        marginRight: theme.spacing(2)
    },
    emphasizedText: {
        fontWeight: "500"
    },
    flagIcon: {
        marginRight: theme.spacing(2.5),
        height: theme.spacing(3),
        width: theme.spacing(3),
    },
    arrowIconRight: {
        position: "absolute",
        right: theme.spacing(2),
        top: theme.spacing(2)
    },
    currencyIndicator: {
        color: theme.palette.secondary["900"]
    },
    menuHeader: {
        paddingLeft: theme.spacing(3)
    },
    ctaButton: {
        width: "50%",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
}));

const SELECTION_TYPE = {
    LANGUAGE: "language",
    CURRENCY: "currency"
};

const HeaderProfileMenu = ({userFullName, menuItems, open, showSnackbar}) => {
    const classes = useStyles();
    const {isExtraSmallScreen} = useBreakpoints();
    const {i18n} = useI18N();
    const {isRouteInLocation} = useLocation();
    const {authenticated, register, login} = useKeycloakFunctions();
    const [{localeSelection}] = useContext(LocaleContext);
    const [{currency, currencyName}] = useContext(CurrencyContext);
    const [selectionMode, setSelectionMode] = useState();
    const {sendCustomEvent, eventNames, userTypes} = useAnalytics();

    useEffect(() => {
        if(open) {
            setSelectionMode(undefined);
        }
    }, [open]);

    const handleOpenSelectionMode = (selectionType) => {
        if (selectionType) {
            setSelectionMode(selectionType);
        }
    };

    const handleCloseSelectionMode = () => {
        setSelectionMode(undefined);
    };

    const doRegister = () => {
        sendCustomEvent({
            event_name: eventNames.SIGN_UP_START_SIDEMENU,
            user_type: userTypes.PROSPECT
        });
        register(window.location.href);
    };

    const handleAuth = async (action) => {
        if(await checkYearEndProcessing()) {
            showSnackbar({
                type: "info",
                message: action === "register" ? i18n("view.auth.label.sign_up_maintenance") : i18n("view.auth.label.sign_in_maintenance"),
                withIcon: true,
                closeIcon: true
            });
        } else {
            window.history.pushState(window.history.state, null, window.location.href);
            return action === "register" ? doRegister() : login();
        }
    };

    return (
        <Box pb={3}>
            {!selectionMode &&
                <>
                    {authenticated &&
                        <Box
                            pt={3}
                            px={3}
                        >
                            <Grid
                                container
                            >
                                <Grid
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    item
                                >
                                    <Typography
                                        variant={"h5"}
                                    >
                                        {userFullName}
                                    </Typography>
                                </Grid>

                                {/* Todo, add values when api requests implemented */}
                                {/* <Grid
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        item
                                                    >
                                                        <Typography
                                                            variant={"caption"}
                                                        >
                                                            {"143 points  2 shares"}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        item
                                                    >
                                                        <Typography
                                                            variant={"caption"}
                                                        >
                                                            {i18n("view.header.profile_menu.next_trip_message", {resortName: "Antives", numOfDays: 1})}
                                                        </Typography>
                                                    </Grid> */}
                            </Grid>
                        </Box>
                    }

                    {/* Top Items */}
                    <MenuList
                        className={clsx(classes.mt2, classes.menuList)}
                    >
                        {menuItems && menuItems.filter(item => item.align === "top" && item?.isVisible)
                            .map((item, index) => {
                                return (
                                    <Box key={index}>
                                        {item?.divider &&
                                            <Divider variant="middle"/>
                                        }
                                        {item?.component ? item.component : (
                                            <MenuItem
                                                className={clsx(item?.variant === "primary" ? classes.profileMenuItemTop : classes.profileMenuItemBottom, {[item.className]: item.className})}
                                                key={item?.id}
                                                e2e-id={item?.id}
                                                onClick={() => {item.onClick(item?.route);}}
                                            >
                                                {item?.icon &&
                                                <StreamlineIcon
                                                    className={item?.iconClass || classes.profileMenuItemIcon}
                                                    size={item?.iconSize || 24}
                                                >
                                                    {item?.icon}
                                                </StreamlineIcon>
                                                }

                                                <Typography
                                                    className={item?.variant === "primary" ? classes.emphasizedText : ""}
                                                    variant={item?.textVariant || "body1"}
                                                >
                                                    {item?.label}
                                                </Typography>
                                            </MenuItem>
                                        )}
                                    </Box>
                                );
                            })
                        }
                    </MenuList>

                    {/* Bottom Items */}
                    <MenuList
                        className={!isExtraSmallScreen() ? classes.menuList : ""}
                    >
                        {isExtraSmallScreen() && !isRouteInLocation(ROUTES.BOOKING) &&
                            <Box>
                                <Divider variant="middle"/>

                                {!isRouteInLocation(ROUTES.MARKET_PLACE) && !isRouteInLocation(ROUTES.RESORTS_BOOKING_INFORMATION) &&
                                    <MenuItem
                                        onClick={() => {handleOpenSelectionMode(SELECTION_TYPE.CURRENCY);}}
                                    >
                                        <Typography
                                            className={classes.currencyIndicator}
                                            variant="subtitle2"
                                        >
                                            {currency}
                                        </Typography>

                                        <Typography
                                            className={classes.ml2}
                                            variant="body1"
                                        >
                                            {currencyName}
                                        </Typography>

                                        <StreamlineIcon
                                            className={classes.arrowIconRight}
                                            size={16}
                                        >
                                            <ArrowRight/>
                                        </StreamlineIcon>
                                    </MenuItem>
                                }

                                <MenuItem onClick={() => {handleOpenSelectionMode(SELECTION_TYPE.LANGUAGE);}}>
                                    <CountryIcon
                                        className={classes.flagIcon}
                                        countryCode={localeSelection.localeSelected === "at_DE" || localeSelection.localeSelected === "ch_DE"
                                            ? localeSelection.localeSelected.toUpperCase().split("_")[0]
                                            : localeSelection.localeSelected.split("_")[1]
                                        }
                                    />

                                    <Typography
                                        variant="body1"
                                    >
                                        {localeSelection?.localeOptions.find(o => o.value === localeSelection.localeSelected)?.label}
                                    </Typography>

                                    <StreamlineIcon
                                        className={classes.arrowIconRight}
                                        size={16}
                                    >
                                        <ArrowRight/>
                                    </StreamlineIcon>
                                </MenuItem>
                            </Box>
                        }

                        {menuItems && menuItems.filter(item => item.align === "bottom" && item?.isVisible)
                            .map((item, index) => {
                                return (
                                    <Box key={index}>
                                        {item?.divider &&
                                            <Divider
                                                variant="middle"
                                            />
                                        }
                                        <MenuItem
                                            className={clsx(classes.profileMenuItemBottom, {[item.className]: item.className})}
                                            key={item?.id}
                                            e2e-id={item?.id}
                                            onClick={() => {item.onClick(item?.route);}}
                                        >
                                            {item?.icon &&
                                            <StreamlineIcon
                                                className={item?.iconClass || classes.profileMenuItemIcon}
                                                size={item?.iconSize || 24}
                                            >
                                                {item?.icon}
                                            </StreamlineIcon>
                                            }

                                            <Typography
                                                variant={item?.textVariant || "body1"}
                                            >
                                                {item?.label}
                                            </Typography>
                                        </MenuItem>
                                    </Box>
                                );
                            })
                        }
                    </MenuList>

                    {!authenticated &&
                        <>
                            <Box mt={1}>
                                <Divider variant="middle" />
                                <Box
                                    mt={2}
                                    px={2}
                                    pb={2}
                                    display={"flex"}
                                >
                                    <CustomButton
                                        size={"small"}
                                        variant={"outlined"}
                                        className={classes.ctaButton}
                                        onClick={() => handleAuth("register")}
                                    >
                                        {toTitleCase(i18n("common.label.register"))}
                                    </CustomButton>

                                    <CustomButton
                                        size={"small"}
                                        variant={"contained"}
                                        className={classes.ctaButton}
                                        onClick={() => handleAuth("login")}
                                    >
                                        {i18n("view.auth.label.sign_in")}
                                    </CustomButton>
                                </Box>
                            </Box>
                        </>
                    }
                </>
            }

            {selectionMode &&
                <>
                    <MenuItem
                        className={classes.menuHeader}
                        onClick={handleCloseSelectionMode}
                    >
                        <StreamlineIcon
                            className={classes.backIcon}
                            size={18}
                        >
                            <ArrowLeft />
                        </StreamlineIcon>

                        <ListItemText>
                            <Typography variant={"h5"}>
                                {selectionMode === SELECTION_TYPE.LANGUAGE ? i18n("view_header.profile_menu.language_selection") : i18n("view.header.profile_menu.currency_selection")}
                            </Typography>
                        </ListItemText>
                    </MenuItem>

                    {selectionMode === SELECTION_TYPE.LANGUAGE ? (
                        <LanguageSelect
                            type="list"
                            handleSelection={handleCloseSelectionMode}
                            hideDividers
                            showSelectedIndicator
                            iconClass={classes.flagIcon}
                            location={"header"}
                        />
                    ) : (
                        <CurrencySelect
                            type="list"
                            handleSelection={handleCloseSelectionMode}
                            hideDividers
                            showSelectedIndicator
                            location={"header"}
                        />
                    )}
                </>
            }
        </Box>
    );
};

HeaderProfileMenu.propTypes = {
    userFullName: PropTypes.string,
    menuItems: PropTypes.array,
    open: PropTypes.bool,
    showSnackbar: PropTypes.func
};


export default withSnackbar(HeaderProfileMenu);
